import { useState } from "react"
import { tradeMT4 } from "../../data/data"

export default function TradeEmbrace() {
  const [cards] = useState(tradeMT4)

  return (
    <>
      <section className="px-5 2xl:px-0 py-10 lg:py-20">
        <h2 className="text-3xl text-center text-gray-800 mb-5 lg:text-5xl">
          Embrace Our Fast <span className="block">Trading Platform</span>
        </h2>
        <p className="text-center">
          Our MT4 trading platform gives you a competitive edge in your market
          with{" "}
          <span className="md:block">
            advanced functionality, superior reliability, and enhanced security.
            The trading
          </span>{" "}
          platform is configured by the experts in our company to provide you
          with
          <span className="md:block">
            a key business and marketing competitive advantage. We offer you:
          </span>
        </p>

        <div className="tech__articles trade__articles pt-10 grid grid-cols-1 gap-10 xl:max-w-6xl xl:mx-auto lg:pt-20 lg:gap-20">
          {cards.map(({ id, image, title, desc }) => (
            <article key={id}>
              <div className="md:mx-5 lg:mx-10">
                <img
                  src={image}
                  alt={title}
                  title={title}
                  className="block mx-auto"
                />
              </div>

              <div className="md:w-1/2">
                <h2 className="text-3xl mb-5 lg:text-5xl">{title}</h2>
                <p>{desc}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  )
}
